module.exports = __webpack_public_path__ + "static/media/logo_header.7fc529c1.png";